import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { RootState } from '../../../../../redux/store';

import { ProcedureParams } from '../../../../../shared/types/systemConfiguration/procedureParams';
import { asyncGetParams } from '../../../../../services/param.service';
import { ParamEnum } from '../../../../../shared/types/shared';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

import { ProcedureParamsListActions } from './actions';

export const useProcedureParamsList = (filters?: ProcedureParams) => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<ProcedureParams[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] = useState<ProcedureParams | object>(
        {}
    );

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };
    const columns: GridColDef<ProcedureParams>[] = [];

    if (!isOnlyViewProfile(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <ProcedureParamsListActions id={row.id} />,
        });
    }
    columns.push(
        {
            field: 'name',
            headerName: 'Nombre',
            minWidth: 120,
            flex: 0.5,
        },
        {
            field: 'active',
            headerName: 'Activo',
            minWidth: 80,
            flex: 0.4,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => <>{row.row.active ? 'Si' : 'No'}</>,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 180,
            flex: 0.6,
            renderCell: (row) => <> {row.row.createdAtFormatted} </>,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        let name: string | undefined;
        let active: boolean | undefined;

        if (
            finalFilters &&
            'name' in finalFilters &&
            'active' in finalFilters
        ) {
            ({ name, active } = finalFilters as {
                name?: string;
                active?: boolean;
            });
        }
        asyncGetParams(
            ParamEnum.PQR_PROCEDURE,
            '',
            '',
            name,
            '',
            active,
            page,
            pageSize
        )
            .then((res: any) => {
                setRows(res?.items);
                setTotal(res?.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
